interface Node {
  readonly id: string
  readonly x: number
  readonly y: number
  readonly r: number
  readonly delay: number
}

interface Edge {
  readonly from: string
  readonly to: string
  readonly delay: number
}

const NODES: readonly Node[] = [
  { id: 'a', x: 120, y: 120, r: 4, delay: 0 },
  { id: 'b', x: 280, y: 80, r: 5, delay: 0.2 },
  { id: 'c', x: 440, y: 160, r: 4, delay: 0.4 },
  { id: 'd', x: 600, y: 100, r: 5, delay: 0.6 },
  { id: 'e', x: 760, y: 200, r: 4, delay: 0.8 },
  { id: 'f', x: 200, y: 280, r: 5, delay: 0.3 },
  { id: 'g', x: 380, y: 340, r: 6, delay: 0.5 },
  { id: 'h', x: 560, y: 300, r: 4, delay: 0.7 },
  { id: 'i', x: 720, y: 380, r: 5, delay: 0.9 },
  { id: 'j', x: 100, y: 440, r: 4, delay: 1.0 },
  { id: 'k', x: 300, y: 480, r: 5, delay: 1.1 },
  { id: 'l', x: 500, y: 460, r: 4, delay: 1.2 },
  { id: 'm', x: 680, y: 520, r: 5, delay: 1.3 },
]

const EDGES: readonly Edge[] = [
  { from: 'a', to: 'b', delay: 0.1 },
  { from: 'b', to: 'c', delay: 0.2 },
  { from: 'c', to: 'd', delay: 0.3 },
  { from: 'd', to: 'e', delay: 0.4 },
  { from: 'a', to: 'f', delay: 0.5 },
  { from: 'b', to: 'g', delay: 0.6 },
  { from: 'c', to: 'g', delay: 0.7 },
  { from: 'd', to: 'h', delay: 0.8 },
  { from: 'e', to: 'i', delay: 0.9 },
  { from: 'f', to: 'g', delay: 1.0 },
  { from: 'g', to: 'h', delay: 1.1 },
  { from: 'h', to: 'i', delay: 1.2 },
  { from: 'f', to: 'j', delay: 1.3 },
  { from: 'g', to: 'k', delay: 1.4 },
  { from: 'h', to: 'l', delay: 1.5 },
  { from: 'i', to: 'm', delay: 1.6 },
  { from: 'j', to: 'k', delay: 1.7 },
  { from: 'k', to: 'l', delay: 1.8 },
  { from: 'l', to: 'm', delay: 1.9 },
]

const NODE_MAP = new Map(NODES.map((n) => [n.id, n]))

export function GraphBackdrop() {
  return (
    <svg
      viewBox="0 0 880 600"
      preserveAspectRatio="xMidYMid slice"
      className="pointer-events-none absolute inset-0 h-full w-full text-foreground opacity-[0.18] dark:opacity-[0.14]"
      aria-hidden
    >
      <g stroke="currentColor" strokeOpacity="0.4" strokeWidth="1.2" fill="none">
        {EDGES.map((e) => {
          const a = NODE_MAP.get(e.from)
          const b = NODE_MAP.get(e.to)
          if (!a || !b) return null
          return (
            <line
              key={`${e.from}-${e.to}`}
              x1={a.x}
              y1={a.y}
              x2={b.x}
              y2={b.y}
              className="landing-graph-line"
              style={{ animationDelay: `${e.delay}s` }}
            />
          )
        })}
      </g>

      <g fill="currentColor" fillOpacity="0.7">
        {NODES.map((n) => (
          <circle
            key={n.id}
            cx={n.x}
            cy={n.y}
            r={n.r}
            className="landing-graph-node"
            style={{ animationDelay: `${n.delay}s` }}
          />
        ))}
      </g>
    </svg>
  )
}
